module.exports = __webpack_public_path__ + "static/img/r1.b21b80b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/r1.png
// module id = bO9w
// module chunks = 0